import React from 'react';
import cn from 'classnames';
import { Typography } from "../Typography";
import { Spinner } from "../Spinner";
import styles from "./PageHeader.module.scss";
import { WideArrowBackward } from "../../icons/WideArrowBackward";
import { IconButton } from "../IconButton";
/** Renders the top content of a page. */
export function PageHeader(props) {
  const {
    title,
    subheader,
    actions,
    loading,
    onClickBack,
    className
  } = props;
  const shouldShowBackButton = Boolean(onClickBack);
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.container, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.leadingArea, {
      [styles.backButtonShown]: shouldShowBackButton
    })
  }, shouldShowBackButton && /*#__PURE__*/React.createElement(IconButton, {
    className: styles.backButton,
    "data-testid": props['data-testid'] && "".concat(props['data-testid'], "-back-button"),
    onClick: onClickBack
  }, /*#__PURE__*/React.createElement(WideArrowBackward, null)), /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement(Typography, {
    as: "span",
    variant: "h4",
    weight: "normal",
    "data-testid": props['data-testid'] && "".concat(props['data-testid'], "-page-header")
  }, title), loading && /*#__PURE__*/React.createElement(Spinner, {
    size: 40,
    "data-testid": "page-loading"
  })), subheader && /*#__PURE__*/React.createElement(Typography, {
    className: styles.subheader,
    "data-testid": props['data-testid'] && "".concat(props['data-testid'], "-page-subheader")
  }, subheader)), /*#__PURE__*/React.createElement("div", {
    className: styles.actions,
    "data-testid": props['data-testid'] && "".concat(props['data-testid'], "-actions")
  }, actions));
}